import React from "react";
import "./style.css";

export const AccessibilityReport = () => {
  document.title = "Timebook - Tillgänglighetsredovisning";
  return (
      <div id={"accessibility-report"}>
        <main>
          <h1>Tillgänglighet för CGM J4 Webbtidbok</h1>
          <p>Lorensbergs Communication AB står bakom den här webbplatsen. Vi vill att så många som möjligt ska kunna använda den. Det här dokumentet beskriver hur CGM J4 Webbtidbok uppfyller lagen om tillgänglighet till digital offentlig service, eventuella kända tillgänglighetsproblem och hur du kan rapportera brister till oss så att vi kan åtgärda dem.</p>

          <h2>Hur tillgänglig är webbplatsen?</h2>
          <p>CGM J4 Webbtidbok skall vara förenlig med lagen om tillgänglighet till digital offentlig service. Eventuella avvikelser från detta redovisas nedan under ”Innehåll som inte är tillgängligt”.</p>

          <h2>Vad kan du göra om du inte kan använda delar av webbplatsen?</h2>
          <p>Om du behöver innehåll från CGM J4 Webbtidbok som inte är tillgängligt för dig, men som är undantaget från lagens tillämpningsområde enligt beskrivning nedan, kontakta oss via e-post.</p>

          <h2>Rapportera brister i systemets tillgänglighet</h2>
          <p>Om du upptäcker problem som inte är beskrivna på den här sidan, eller om du anser att vi inte uppfyller lagens krav, kontakta oss via e-post så att vi får veta att problemet finns.</p>

          <h2>Kontaktuppgifter</h2>
          <p>Du kontaktar oss genom att skicka e-post till <a href={"mailto:tillganglighetcgmj4@cgm.com"} rel="noopener noreferrer">tillganglighetcgmj4@cgm.com</a>.</p>

          <h2>Tillsyn</h2>
          <p>Myndigheten för digital förvaltning, Digg, har ansvaret för tillsyn över lagen om tillgänglighet till digital offentlig service. Du kan anmäla till Digg om du tycker att vår digitala service har brister i tillgänglighet.</p>
          <p>Du kan också anmäla till Digg om du tycker att vår bedömning av vad som är oskäligt betungande ska granskas, om du tycker att vår tillgänglighetsredogörelse har brister eller om du tycker att vi inte har hanterat din begäran om tillgängliggörande korrekt.</p>
          <p>Anmäla till Digg gör du på <a href={"https://www.digg.se/tdosanmalan"} target={"_blank"} rel="noopener noreferrer">Diggs hemsida</a>.</p>

          <h2>Teknisk information om systemets tillgänglighet</h2>
          <p>CGM J4 Webbtidbok är helt förenlig med lagen om tillgänglighet till digital offentlig service och riktlinjerna i Web Content Accessibility Guidelines (WCAG) 2.1, nivå A och AA. Om brister upptäcks redovisas detta nedan.</p>

          <h2>Innehåll som inte är tillgängligt</h2>
          <h3>Bristande förenlighet med lagkraven</h3>
          <p>CGM J4 Webbtidbok innehåller inga kända brister.</p>

          <h3>Oskäligt betungande anpassning</h3>
          <p>Lorensbergs Communication AB åberopar inga undantag för oskäligt betungande anpassning enligt 12§ lagen om tillgänglighet till digital offentlig service.</p>

          <h3>Innehåll som inte omfattas av lagen</h3>
          <p>CGM J4 Webbtidbok innehåller inga delar som undantas enligt 9 § lagen om tillgänglighet till digital offentlig service.</p>

          <h2>Hur vi testat CGM J4 Webbtidbok</h2>
          <p>Vi har gjort en självskattning (intern testning) av CGM J4 Webbtidbok med hjälp av verktyget WAVE Web Accessibility Evaluation Tool.</p>
          <p>Senaste bedömningen gjordes den 17:e december 2025, version 3.6.0.</p>
          <p>Redogörelsen uppdaterades senast den 17:e december 2025.</p>
        </main>
      </div>
  );
};
